import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  saved_query: {
    read: ["all"],
    config: ["master", "administrator", "program_manager"],
    create: ["master", "program_manager", "administrator", "staff", "client"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator"]
  },
  insight: {
    read: ["all"],
    create: ["master", "program_manager", "administrator", "staff", "client"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator", "staff", "client"],
    config: ["master", "program_manager", "administrator"]
  }
};
